<template>
  <div v-if="!loading">
    <span
      v-if="languages.length === 1"
      :class="['single-language', isZkm && 'single-language-zkm']"
    >{{ selected }}</span>
    <div v-else class="custom-select">
      <select v-model="selected" @change="switchLanguage($event)">
        <option v-for="(language, i) in languages" :key="`language-${i}`" :value="language">
          {{ language }}
        </option>
      </select>
      <v-icon class="select-icon" color="black">
        expand_more
      </v-icon>
    </div>
  </div>
</template>

<script>
import i18next from 'i18next'
import { GET_LANGUAGE_CODES_FOR_EVENT } from '../../graphql/translation.graphql'

export default {
  name: 'switch-locale',
  props: {
    eventSlug: {
      default: () => null,
      type: String,
    },
    isZkm: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      selected: i18next.resolvedLanguage.toLowerCase(),
      languages: ['hr', 'en'],
      loading: true,
    }
  },
  methods: {
    switchLanguage(event) {
      const newLang = event.target.value.toLowerCase()
      i18next.changeLanguage(newLang)
      this.$router.push({ query: { ...this.$route.query, lang: newLang } })
    },
    getLanguageCodeFromQueryParams() {
      const params = new URL(window.location.href).searchParams

      return params.get('lang')
    },
  },
  apollo: {
    getLanguageCodesForEvent: {
      query: GET_LANGUAGE_CODES_FOR_EVENT,
      variables() {
        return {
          slug: this.eventSlug,
        }
      },
      skip() {
        return !this.eventSlug
      },
      manual: true,
      async result({ loading, data }) {
        if (!loading) {
          const fetchedLanguages = data.getLangugeCodesForEvent || []

          // Merge without overwriting default languages
          this.languages = Array.from(new Set([...this.languages, ...fetchedLanguages]))

          const fallbackLang = this.getLanguageCodeFromQueryParams()

          this.selected = fallbackLang || fetchedLanguages[0] || this.selected
          await i18next.changeLanguage(this.selected.toLowerCase())
          this.$router.push({ query: { ...this.$route.query, lang: this.selected } })

          this.loading = false
        }
      },
    },
  },
}
</script>

<style>
select {
  line-height: 120%;
  height: 38px;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  outline: 0;
}
.single-language {
  line-height: 120%;
  height: 38px;
  font-size: 18px;
  font-weight: 700;
  color: #0277bd;
  text-transform: uppercase;
  outline: 0;
}
.single-language-zkm {
  color: #333333;
}

.custom-select {
  position: relative;
  display: inline-block;
  width: fit-content;
}

select {
  padding: 8px 35px 8px 10px; /* Space for the icon */
  border-radius: 4px;
  font-size: 18px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  appearance: none; /* Remove default dropdown arrow */
  width: 100%;
}

.select-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none; /* Prevent interaction */
}
</style>
